import debounce from 'lodash/debounce';

export class Ticker {   
    constructor(el) {
        if (!el) return;

        this.context = el;
        this.contentToClone = this.context.querySelector('.js-ticker-content');

        window.addEventListener('load', () => {
            this.init();
        });
    }

    init () {
        this.setContent();
        this.context.classList.remove('opacity-0');

        const debouncedResizeCallBack = debounce(this.resizeCallback, 200);

        window.addEventListener('resize', debouncedResizeCallBack.bind(this));
    }

    resizeCallback () {
        this.resetContent();
        this.setContent();
    }

    resetContent () {
        const clonedContent = [...this.context.querySelectorAll('.js-ticker-content-clone')];

        if (clonedContent.length) clonedContent.forEach(el => el.remove());
    }

    setContent () {
        const amountToClone = Math.ceil(window.innerWidth / this.contentToClone.getBoundingClientRect().width) * 2;

        for (let i = 1; i < amountToClone; i++) {
            const contentCloned = this.contentToClone.cloneNode('deep');

            contentCloned.classList.add('js-ticker-content-clone')
            contentCloned.ariaHidden = true;

            this.context.appendChild(contentCloned);
        }

        let animationDuration = this.context.dataset.jsTickerAnimationDuration;

        if (((animationDuration / 1440) * window.innerWidth) < this.context.dataset.jsTickerAnimationDuration) {
            animationDuration = this.context.dataset.jsTickerAnimationDuration;
        } else {
            animationDuration = (animationDuration / 1440) * window.innerWidth;
        }

        this.context.style.animationDuration = `${animationDuration}s`;
    }
}
